export const START_LOAD = 'source/START_LOAD';
export const FINISH_LOAD = 'source/FINISH_LOAD';

const initialState = {
    loading:false,
    source:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, source:action.payload};
        default: return state;
    }
}